import type {
  dealerSearchIncoming,
  dealerSearchOutgoingInternal,
  dealerSearchOutgoingInternalError
} from "@dealer-center/ddc-pages-account-search-interface";
import { isDealerSearchOutgoingInternalError } from "@dealer-center/ddc-pages-account-search-interface";
import { convertData, getOptions, getUrlToUse } from "./helper";
import { useQuery } from "@tanstack/react-query";

interface queryKeyInterface {
  queryKey: [
    string,
    {
      page: number;
      size: number;
      searchRequest: dealerSearchIncoming;
    }
  ];
}

function fetchAccountSearchGet({ queryKey }: queryKeyInterface) {
  const [, { page, size, searchRequest }] = queryKey;
  if (!searchRequest) throw new Error("request is required");
  const from = page * size;
  const url = getUrlToUse(from, size);
  const options = getOptions(searchRequest);
  return fetch(url, options)
    .then(response => {
      if (!response.ok) {
        throw new Error(response.statusText);
      } else {
        return response.json() as Promise<
          dealerSearchOutgoingInternal | dealerSearchOutgoingInternalError
        >;
      }
    })
    .then(data => {
      if (isDealerSearchOutgoingInternalError(data)) {
        throw new Error(data.message);
      }
      return convertData(data, null, searchRequest);
    });
}

export function useAccountSearchGet({
  page,
  size,
  searchRequest,
  disabled
}: {
  page: number;
  size: number;
  searchRequest: dealerSearchIncoming;
  disabled: boolean;
}) {
  return useQuery({
    queryKey: ["useAccountSearchGet", { page, size, searchRequest }],
    queryFn: fetchAccountSearchGet,
    enabled: !disabled,
    gcTime: 0
  });
}
